// Hasta listesi hücreleri için saf biçimlendirme yardımcıları.
import { ACCENTS } from "../../../styles/uiConstants";

const DAY_MS = 24 * 60 * 60 * 1000;
const TR_MONTHS = ["Oca", "Şub", "Mar", "Nis", "May", "Haz", "Tem", "Ağu", "Eyl", "Eki", "Kas", "Ara"];

export const fullName = (p) => `${p?.name || ""} ${p?.surname || ""}`.trim() || "—";

export const initialsOf = (p) =>
  `${((p?.name || "")[0] || "").toLocaleUpperCase("tr")}${((p?.surname || "")[0] || "").toLocaleUpperCase("tr")}` || "?";

/** İsme göre sabit avatar tonu — aynı hasta her yerde aynı renkte. */
const AVATAR_TONES = [ACCENTS.blue, ACCENTS.violet, ACCENTS.cyan, ACCENTS.indigo, ACCENTS.amber, ACCENTS.emerald];
export const avatarTone = (p) => {
  const key = `${p?.name || ""}${p?.surname || ""}`;
  let h = 0;
  for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) >>> 0;
  return AVATAR_TONES[h % AVATAR_TONES.length];
};

export const ageOf = (birthDay) => {
  if (!birthDay) return null;
  const d = new Date(birthDay);
  if (Number.isNaN(d.getTime())) return null;
  const now = new Date();
  let age = now.getFullYear() - d.getFullYear();
  const m = now.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < d.getDate())) age -= 1;
  return age >= 0 ? age : null;
};

/** KVKK: listede TC maskelenir — 12345678914 → 123******14 */
export const maskTc = (tc) => (tc && tc.length === 11 ? `${tc.slice(0, 3)}******${tc.slice(-2)}` : tc || "");

const startOfDay = (d) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};
const dayDiff = (d) => Math.round((startOfDay(d) - startOfDay(new Date())) / DAY_MS);
const hhmm = (d) => d.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" });
const shortDate = (d) => `${d.getDate()} ${TR_MONTHS[d.getMonth()]}${d.getFullYear() !== new Date().getFullYear() ? ` ${d.getFullYear()}` : ""}`;

export const fullDateTime = (v) =>
  v ? new Date(v).toLocaleString("tr-TR", { day: "2-digit", month: "long", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "";

/** Geçmiş tarih: "Bugün", "Dün", "5 gün önce", "3 hafta önce", "4 ay önce" */
export const relativePast = (v) => {
  if (!v) return null;
  const diff = -dayDiff(new Date(v));
  if (diff <= 0) return "Bugün";
  if (diff === 1) return "Dün";
  if (diff < 14) return `${diff} gün önce`;
  if (diff < 60) return `${Math.round(diff / 7)} hafta önce`;
  if (diff < 365) return `${Math.round(diff / 30)} ay önce`;
  return `${Math.round(diff / 365)} yıl önce`;
};

/** Gelecek randevu: "Bugün 14:20", "Yarın 09:00", "8 Eki 10:20" */
export const upcomingLabel = (v) => {
  if (!v) return null;
  const d = new Date(v);
  const diff = dayDiff(d);
  if (diff === 0) return `Bugün ${hhmm(d)}`;
  if (diff === 1) return `Yarın ${hhmm(d)}`;
  return `${shortDate(d)} ${hhmm(d)}`;
};

export const isSoon = (v) => v != null && dayDiff(new Date(v)) <= 1;

const val = (values, key) => (values || []).find((x) => x.key === key)?.value;
const fmt = (n, digits = 0) =>
  n == null ? "—" : Number(n).toLocaleString("tr-TR", { minimumFractionDigits: digits, maximumFractionDigits: digits });

/** Son ölçümün kısa özeti: { label: "Tansiyon", value: "145/92" } */
export const measurementSummary = (m) => {
  if (!m) return null;
  const v = (k) => val(m.values, k);
  switch (m.metricType) {
    case "blood_pressure":
      return { label: "Tansiyon", value: `${fmt(v("systolic"))}/${fmt(v("diastolic"))}` };
    case "blood_glucose":
      return { label: "Şeker", value: `${fmt(v("glucose"))} mg/dL` };
    case "spo2":
      return { label: "SpO₂", value: `%${fmt(v("spo2"))}` };
    case "body_temperature":
      return { label: "Ateş", value: `${fmt(v("temperature"), 1)} °C` };
    case "heart_rate":
      return { label: "Nabız", value: `${fmt(v("heartRate"))} bpm` };
    case "weight":
      return { label: "Kilo", value: `${fmt(v("weight"), 1)} kg` };
    case "body_composition":
      return { label: "Vücut analizi", value: v("weight") != null ? `${fmt(v("weight"), 1)} kg` : "" };
    case "body_circumference":
      return { label: "Bel", value: v("waist") != null ? `${fmt(v("waist"), 1)} cm` : "" };
    default:
      return { label: "Ölçüm", value: "" };
  }
};
